<label
  [ngStyle]="{
    width: '100%',
    height: '100%',
    fontFamily: initOptions.fontFamily,
    fontWeight: initOptions.fontWeight,
    fontSize: initOptions.fontSize + 'px'
  }"
  class="label {{ initOptions.style }}">
  {{ initOptions.inner_text }}
</label>
